import * as React from 'react';
import { useSelector } from 'react-redux';
import { EPageTypes, EPlatformTypes, handleDynamicCalltracking } from '@cian/frontend-newbuilding-call-component';
import { Button } from '@cian/ui-kit';

import { INewbuildingBuilder, ISeller } from '../../types/newbuilding/builder';

import { trackShowPhone } from '../../analytics/call';

import { phoneToString } from '../../utils/phone/phoneToString';
import { gaLabelSelector } from 'shared/selectors/newbuilding';
import { useApplicationContext } from 'shared/utils/applicationContext';

export interface ICallBuilderContainerProps {
  placeType?: string;
  target: INewbuildingBuilder | ISeller;
}

export const CallBuilderContainer: React.FC<ICallBuilderContainerProps> = ({ placeType = 'CallBuilder', target }) => {
  const gaLabel = useSelector(gaLabelSelector);
  const { httpApi, logger } = useApplicationContext();

  const trackActionOpenContactsCall = React.useCallback(() => {
    trackShowPhone('Open_jk_card', gaLabel);
  }, [gaLabel, target]);

  const phone = phoneToString(target.phone);
  const siteBlockId = target.dynamicCalltracking?.siteBlockId;

  const handleClick = React.useCallback(async () => {
    let dynamicPhone = null;

    if (siteBlockId) {
      const response = await handleDynamicCalltracking({
        logger,
        httpApi,
        blockId: siteBlockId,
        platformType: EPlatformTypes.WebMobile,
        pageType: EPageTypes.NewbuildingCard,
        placeType,
      });

      dynamicPhone = response.notFormattedPhone ? `+${response.notFormattedPhone}` : response.notFormattedPhone;
    }

    trackActionOpenContactsCall();

    const tel = dynamicPhone || phone;
    window.location.href = `tel:${tel}`;
  }, [httpApi, logger, phone, placeType, siteBlockId, trackActionOpenContactsCall]);

  /* istanbul ignore next */
  if (!phone) {
    return null;
  }

  return (
    <Button data-testid="CallText" onClick={handleClick} fullWidth>
      Позвонить
    </Button>
  );
};
